export const permissionMapping = {
    "viewclient": ["Client"],
    "viewplan": ["Package"],
    "viewcategory": ["Category"],
    "viewsignal": ["OpenSignal", "CloseSignal"],
    "viewnews": ["News"],
    "viewbanner": ["Banner"],
    "viewcoupon": ["Coupon"],
    "viewblogs": ["Blogs"],
    "viewfaq": ["FAQ"],
    "viewfreeclient": ["FreeTrialClient"],
    "perform": ["Performance"],
    "vewbasket": ["BasketDetail", "BasketStockPublished"],
    "allbaskethistory": ["SubscriptionHistory"],
    "paymenthistory": ["PaymentHistory"],
    "planexpiry": ["ClientPlanExpiry", "PlanExpiry"],
    "ticket": ["HelpDisk"],
    "broadcast": ["BroadcastSMS"]
};




